// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aQx6FrqT_hcdiCDmBGmE{text-align:center}.PJ8TcFVlccQJkbJc1yOZ{cursor:pointer}.nEYijtq1GB4O8MpqsyWo{background-color:var(--background-neutral-subtle);border-radius:8px;align-items:center;gap:8px;padding:16px;display:flex}.XJKRRK1cpKKpQ4Ao9_wq{background:var(--black-20);border-radius:6px;justify-content:center;align-items:center;width:20px;height:20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `aQx6FrqT_hcdiCDmBGmE`,
	"link": `PJ8TcFVlccQJkbJc1yOZ`,
	"step": `nEYijtq1GB4O8MpqsyWo`,
	"step__number": `XJKRRK1cpKKpQ4Ao9_wq`,
	"stepNumber": `XJKRRK1cpKKpQ4Ao9_wq`
};
export default ___CSS_LOADER_EXPORT___;
